/* PDP background lift: product pages don't know the seller, so ask Meili for
   this handle's seller_bgfix and tag the gallery with the matching curve class. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var handle = location.pathname.split('/products/')[1].split('?')[0].split('#')[0];
  if (!handle) return;
  var SEARCH = 'https://search.collectoredit.com';
  var TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZWFyY2hSdWxlcyI6eyJwcm9kdWN0cyI6eyJmaWx0ZXIiOiJzdG9yZXMgPSBjb2xsZWN0b3JlZGl0In19LCJhcGlLZXlVaWQiOiI0M2ZlY2Y1Mi02YWMwLTRkNTAtOWNjYi1lMGViZGY4YjIzNjYifQ.d_kwOHo_K8a-Ngz_EF2AHuUhIfBHWsbdbZLV9seHW6s';
  function tag(knee) {
    if (!knee) return;
    var cls = 'ce-pdp--bg' + knee;
    document.documentElement.classList.add(cls);
  }
  try {
    fetch(SEARCH + '/indexes/products/search', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + TOKEN, 'Content-Type': 'application/json' },
      body: JSON.stringify({ q: '', filter: 'handle_ce = "' + handle + '"', limit: 1,
                             attributesToRetrieve: ['seller_bgfix'] })
    }).then(function (r) { return r.json(); }).then(function (d) {
      var h = (d && d.hits && d.hits[0]) || null;
      if (h && h.seller_bgfix) tag(h.seller_bgfix);
    }).catch(function () {});
  } catch (e) {}
})();


/* Zoomed gallery: allow closing by clicking outside the image (backdrop-close).
   Previously only the small X in the corner worked, which is easy to miss. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  document.addEventListener('click', function (e) {
    var dlg = document.querySelector('dialog.dialog-zoomed-gallery__dialog[open]')
           || document.querySelector('dialog[open].dialog-zoomed-gallery__dialog');
    if (!dlg) return;
    // ignore clicks on the media, thumbnails or any control inside the sheet
    if (e.target.closest('img, button, a, .dialog-thumbnails-list-container, [class*="thumbnail"], [class*="slideshow"]')) return;
    var r = dlg.getBoundingClientRect();
    var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    // click on the backdrop, or inside the sheet but not on any content
    if (!inside || e.target === dlg) {
      try { dlg.close(); } catch (err) { dlg.removeAttribute('open'); }
    }
  }, true);
})();
